import {
  RemoteBrandLogo28,
  RemoteAffiliatesLogo28,
  RemotePartnersLogo28,
  RemoteConnectLogo28,
} from 'remote-com-shared/components/Brand/Logo';
import { whenProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

export const RemoteLogo = styled(RemoteBrandLogo28)`
  display: block;
  width: auto;
  height: var(--headerBrandHeight);
  ${sharedTransition('color')}
  color: var(--colors-blank);

  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      color: var(--newBrandColor);
    `
  )}
`;
export const RemoteAffiliatesLogo = styled(RemoteAffiliatesLogo28)`
  display: block;
  width: auto;
  color: var(--colors-blank);
  ${sharedTransition('color')}

  [fill='#75E8F0'] {
    ${sharedTransition('fill')}
  }

  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      color: var(--newBrandColor);

      [fill='#75E8F0'] {
        fill: var(--colors-darkBlue);
      }
    `
  )}
`;
export const RemotePartnersLogo = styled(RemotePartnersLogo28)`
  display: block;
  width: auto;
  color: var(--colors-blank);
  ${sharedTransition('color')}

  [fill='#75E8F0'] {
    ${sharedTransition('fill')}
  }

  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      color: var(--newBrandColor);

      [fill='#75E8F0'] {
        fill: var(--colors-darkBlue);
      }
    `
  )}
`;

export const RemoteConnectLogo = styled(RemoteConnectLogo28)`
  display: block;
  width: auto;
  color: var(--colors-blank);
  ${sharedTransition('color')}

  [fill='#75E8F0'] {
    ${sharedTransition('fill')}
  }

  ${whenProp(
    ['$isFixed', '$isOpen'],
    css`
      color: var(--newBrandColor);

      [fill='#FFD012'] {
        fill: var(--colors-darkBlue);
      }
    `
  )}
`;

export default RemoteLogo;
